import React from 'react';
import CreatePage from './CreatePage';
import { useAuth } from 'authentication';
import { httpClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';
import AppNotificationContainer from 'components/AppNotificationContainer';
import JobNavigation from './JobNavigation';
import SectionNavigation from './SectionNavigation';
import * as documentFunction from 'components/UIBuilder/SectionFunction/Document';
import { config } from 'util/config';
import { useHistory } from "react-router-dom";
import BookingRequest from './BookingRequest/index';

const PublicDetail = () => {
  const { authUser, setAuthUser } = useAuth();
  const areaName = "Business";
  const pageName = "PublicDetail";
  const history = useHistory();

  let pathname = window.location.pathname.split('/');

  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <PublicDetailPage authUser={authUser} setAuthUser={setAuthUser} areaName={areaName} pageName={pageName} accessCode={pathname[pathname.length - 1]} history={history} />
  )
}
export default PublicDetail;

class PublicDetailPage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      searchParameter: {
        accessCode: props.accessCode
      },
      defaultFormData: {
        accessCode: props.accessCode
      },
      module: '',
      moduleId: 0,
      state: '',
      mouseEvent: {},
      loaded: false,
      loading: true,
      jobData: {},
      sectionData: [],
      publicHoliday: [],
      page: null,
      webUIConfig: null,
      stampedDocColor: '#00A143',
      subjobData: {},
      bookingRequestShow: false,
    }

    this.jobNavigation = React.createRef();
    this.sectionNavigation = React.createRef();
    this.bookingRequest = React.createRef();
    this.createPage = React.createRef();
  }

  //查询该Job的module
  componentDidMount() {
    this.getJob();
  }

  getJob() {
    let that = this;
    httpClient
      .get('/Business/Job/Public?accessCode=' + this.props.accessCode)
      .then(({ data }) => {
        if (data.result) {
          this.setState({
            jobData: data.data, module: data.data.ModuleName, moduleId: data.data.ModuleId, state: data.data.PptState, stampedDocColor: data.data.ModuleConfig.StampedDocColor
          });
          document.title = data.data.JobNum + ' - ' + data.data.PptAddress;

          this.getWebUI();
          this.getPublicSubJobBlockDates();
        } else {
          this.setState({ loading: false });
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        that.setState({ loading: false });
        globalFunction.handleError(error, that);
      });
  }

  getWebUI() {
    let that = this;
    httpClient
      .get('/System/WebUI/GetPublicWebUI?accessCode=' + this.props.accessCode)
      .then(({ data }) => {
        if (data.result) {
          globalFunction.decompressData(data.data.webUIConfig).then(function (data) {
            console.log(data);
            that.setState({ webUIConfig: data, loaded: true, loading: false });
          }).catch(function (error) {
            globalFunction.handleResultError(data, this);
          });

        } else {
          this.setState({ loading: false });
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        that.setState({ loading: false });
        globalFunction.handleError(error, that);
      });
  }

  getPublicSubJobBlockDates() {
    let that = this;
    httpClient
      .get('/Admin/SubJobBlockDates/GetPublicSubJobBlockDates?accessCode=' + this.props.accessCode)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ publicHoliday: data.data.map(item => globalFunction.formatDate(item.Date)) });
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  render() {
    return (
      <div>
        {
          this.state.loaded ?
            <div className='public-detail'>
              <BookingRequest ref={this.bookingRequest} jobData={this.state.jobData} subjobData={this.state.subjobData} component={this} pageComponent={this} />
              <div className='ant-layout-header full-layout-header' style={{ margin: '0px', top: '0px' }}>
                <img alt="logo" className="sidebar-Logo" src={("/assets/images/company-logo/" + this.state.jobData.CompanyId + ".png?t=" + globalFunction.formatDateToVersion())} />
              </div>
              <JobNavigation ref={this.jobNavigation} jobData={this.state.jobData} webUIConfig={this.state.webUIConfig} component={this} pageComponent={this} />
              {
                this.state.page != null ? <SectionNavigation ref={this.sectionNavigation} page={this.state.page} component={this} /> : <></>
              }
              <div
                className="job-detail-div"
                style={{ padding: '80px 20px 20px 20px' }}
                onDragOver={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  let sectionComponent = globalFunction.getSectionComponent(this, 'Document');
                  if (sectionComponent != null) {
                    documentFunction.addBySection({ sectionComponent: sectionComponent });
                    documentFunction.dropDocument({ e: e, component: sectionComponent.child.current?.uploadDocument.current });
                    setTimeout(() => {
                      sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
                    }, config.setTimeoutMilliSecond);
                  }
                }}
              >
                <CreatePage
                  {...this.props}
                  ref={this.createPage}
                  module={this.state.module}
                  moduleId={this.state.moduleId}
                  state={this.state.state}
                  searchParameter={this.state.searchParameter}
                  defaultFormData={this.state.defaultFormData}
                  companyId={this.state.jobData.CompanyId}
                  objId={this.state.jobData.JobId}
                  jobId={this.state.jobData.JobId}
                  accessCode={this.state.jobData.AccessCode}
                  uploadUrl={'/Business/Document/PublicUpload'}
                  webUIConfig={this.state.webUIConfig}
                  pageComponent={this} /></div>
            </div> : <AppNotificationContainer loading={this.state.loading} error={''} />
        }
      </div>
    );
  }
};
